/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const oAuthProviderConfigSchema = z.object({
  authorizationUrl: z.string(),
  extraParams: z.object({}).catchall(z.string()),
  tokenUrl: z.string(),
});
